import React from "react";
import Input from "../input/Input";
import Select from "../select/Select";
import styles from "./DynamicAttributeField.module.scss";

interface AttributeValue {
  id: number;
  name: string;
}

interface Attribute {
  id: number;
  name: string;
  type: string;
  values?: AttributeValue[];
}

interface DynamicAttributeFieldProps {
  attribute: Attribute;
  value: any;
  error?: string;
  onChange: (attribute_id: number, value: any) => void;
}

const DynamicAttributeField: React.FC<DynamicAttributeFieldProps> = ({
  attribute,
  value,
  error,
  onChange,
}) => {
  const type = attribute.type;

  switch (type) {
    case "text":
      return (
        <Input
          label={attribute.name}
          placeholder={attribute.name}
          value={value || ""}
          onChange={(e) => onChange(attribute.id, e.target.value)}
          error={error}
          className={styles.input}
        />
      );

    case "select":
      return (
        <Select
          label={attribute.name}
          value={value || ""}
          options={
            attribute.values?.map((v) => ({
              id: String(v.id),
              name: v.name,
            })) || []
          }
          onChange={(value) => {
            if (value) {
              onChange(attribute.id, value.name);
            }
          }}
          error={error}
          className={styles.input}
        />
      );
    case "checkbox":
      return (
        <div className={styles.checkbox_group}>
          <p>{attribute.name}</p>
          {attribute.values?.map((v, idx) => {
            const selectedValues = value ? value.split(",") : [];

            return (
              <label key={idx} className={styles.checkbox_label}>
                <input
                  type="checkbox"
                  checked={selectedValues.includes(v.name)}
                  onChange={(e) => {
                    let newValues = [...selectedValues];

                    if (e.target.checked) {
                      newValues.push(v.name);
                    } else {
                      newValues = newValues.filter((val) => val !== v.name);
                    }
                    onChange(attribute.id, newValues.join(","));
                  }}
                />
                {v.name}
              </label>
            );
          })}
          {error && <span className={styles.error}>{error}</span>}
        </div>
      );
    case "date":
      return (
        <Input
          type="date"
          label={attribute.name}
          value={value || ""}
          onChange={(e) => onChange(attribute.id, e.target.value)}
          error={error}
          className={styles.input}
        />
      );

    default:
      return null;
  }
};

export default DynamicAttributeField;
